import axios from 'axios';

const url = process.env.REACT_APP_AUTHENTICATION_API;
const TIMEOUT = 60000;

export const setAuthenticationApi = async (credendials) => {
  try {
    const { data } = await axios({
    method: 'POST',
    url: `${url}/auth/login`,
    data: credendials,
    timeout: TIMEOUT,
    });
    return data;
  } catch (error) {
    if (error.code === 'ERR_NETWORK') {
      return { errorMessage: 'Não foi possivel se comunicar com o servidor.' };
    }
    if (error.code === 'ECONNABORTED') {
      return { errorMessage: `O tempo limite de espera ${TIMEOUT / 1000} segundos foi excedido.` };
    } else if (error.response) {
      if (error.response.data.message) {
        return { errorMessage: error.response.data.message };
      }
    }
    const newError = { errorMessage: error.message };
    return newError;
  }
}
